import { FC, useState } from "react";

import {
    ITest,
    LabelPosition,
    RHookFormMaskedTextFieldWithLabel,
    RHookFormNumberFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

interface IRemittanceYearToDateFieldsRightPanel extends ITest {
    isAdminUser: any;
    selectedSplit:number
}
export const RemittanceYearToDateFieldsRightPanel: FC<
    IRemittanceYearToDateFieldsRightPanel
> = ({ isAdminUser, selectedSplit }) => {
    // const [selectedSplit, setSelectedSplit] = useState(100);

    return (
        <>
            <RHookFormNumberFieldWithLabel
                id="taxesRemitted"
                testId={`taxes-remitted`}
                label="Taxes Remitted"
                labelPosition={LabelPosition.Top}
            />
             <RHookFormNumberFieldWithLabel
                id="hsfRemitted"
                testId={`hsf-remitted`}
                label="HSF Remitted"
                labelPosition={LabelPosition.Top}
            />
             <RHookFormNumberFieldWithLabel
                id="csstRemitted"
                testId={`csst-remitted`}
                label="CSST Remitted"
                labelPosition={LabelPosition.Top}
            />
        </>
    );
};
